module.exports = __webpack_public_path__ + "static/media/popoverUnsubscribed.d24b3cb0.png";